import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import GuestySearchComponent from "components/SectionHeroArchivePage/GuestySearchComponent";
import React, { FC, useState } from "react";
//import SectionGridFilterCard from "./ListingsGridFilterCard";
import CalendarViewFilterCard from "./CalendarViewFilterCard";
import { Helmet } from "react-helmet-async";
import { useClient } from "../../ClientContext";
import { useGetListings } from "hooks/useGetListings";
//import AlternativeView from "./alternativeView";

//translation
import { useTranslation } from "react-i18next";

export interface ListingGuestyPageProps {
  className?: string;
}

interface Location {
  city: string;
  country: string;
  state: string;
}

const ListingCalendarView: FC<ListingGuestyPageProps> = ({
  className = "",
}) => {
  const {
    noListingsFound,
  } = useClient();
  const [noResults, setNoResults] = useState(false);


  const { t } = useTranslation();

  const { listings, listingsLoading,listingsError:error, handleSearch } = useGetListings();
  // Display loading and error states
  if (error) return <div className="error">Error: {error.message}</div>;
  return (
    <div
      className={`nc-ListingStayPage relative overflow-hidden ${className}`}
      data-nc-id="ListingStayPage"
    >
      <Helmet>
        <title>Booking</title>
      </Helmet>

      <BgGlassmorphism />
      <div className="container relative overflow-hidden">
        <GuestySearchComponent
          className="pt-10 pb-24 lg:pb-28 lg:pt-16"
          onSearch={handleSearch}
        />

        {noResults || noListingsFound ? (
          <div className="text-center mb-10 p-6 bg-gray-100 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              {t("No Results Found")}
            </h2>
            <p className="text-gray-600">
              {t(
                "Sorry, we couldn't find any listings that match your search criteria. It is also possible that we are fully booked for the selected dates. Please try adjusting your filters or search terms."
              )}
            </p>
          </div>
        ) : (
          <CalendarViewFilterCard
            loading={ listingsLoading}
            className="pb-24 lg:pb-28"
            listings={listings || []}
          />
        )}

        
      </div>
    </div>
  );
};

export default ListingCalendarView;
